import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable"
};
const _hoisted_3 = {
  class: "modal-header"
};
const _hoisted_4 = {
  class: "modal-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: $props.id,
    class: "modal",
    "aria-hidden": "true"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["modal-content", $options.compTheme])
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h5", _hoisted_4, _toDisplayString($props.title), 1), _renderSlot(_ctx.$slots, "header"), _createElementVNode("button", {
    class: _normalizeClass(["btn-close", $options.compCloseButton]),
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, null, 2)]), _createElementVNode("div", {
    class: _normalizeClass(["modal-body", $options.compTheme])
  }, [_renderSlot(_ctx.$slots, "default")], 2)], 2)])], 8, _hoisted_1);
}